import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "autocomplete-popup__close-button-container q-d-none q-d-md-block" }

import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClosePopupButtonDestkop',
  setup(__props) {

const popupStore = usePopupStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      id: "autocomplete-popup__close-button",
      class: "autocomplete-popup__close-button q-btn q-btn-close q-btn-lg",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(popupStore).hideAutocomplete && _unref(popupStore).hideAutocomplete(...args)))
    })
  ]))
}
}

})